@if (isCopied) {<div class="copied-notification">Data Copied!</div>}
<div #gridcontainer>
  <div *ngIf="isGridValid">
   <div class="form-group search-group" *ngIf="gridProperties.enableFiltering">
     <div class="page-count">
   
         <div *ngIf="gridProperties.enableFiltering" class="col-sm-12 col-md-7 search-field">
           <label for="searchField">
             <div class="search-label">{{searchLabel}}</div>
           </label>
           <div class="search">
             <!--<label for="searchField" *ngIf="gridProperties.showPaginationIndex && showTable && paginations.totalRecords">
               <div class="hide-element">Search Field</div>
             </label>-->
             <div class="searchBox-label">Search</div>
             <input   [attr.aria-describedby]="searchMessage? 'error-id' : null" [formControl]="ctnNumbertoFormate" type="search" 
               id="searchField" [ctnmask]="false" [numberOnly]="numericSearch" [imeimask]="false" (rawChange)="rawPhone=$event" #searchValue
               (keydown.enter)="filter(searchValue.value)" aria-label="Search." class="form-control" [attr.maxlength]="maxLength" [attr.placeholder]="searchPlaceHolder"/>
               <span class="search-icon" *ngIf="!showBackLink" (keydown.enter)="filter(searchValue.value)" 
               (click)="filter(searchValue.value)" aria-label="Search.">
                 <i tabindex="0" class = "icon-controls-magnifyingglass" aria-hidden="false"></i>
               </span>
               <span class="search-icon" *ngIf="showBackLink" (keydown.enter)="filter('', true)" (click)="filter('', true)" aria-label="clear Search">
                 <i tabindex="0" class = "icon-close" aria-hidden="false"></i>
               </span>
           </div>
           <div *ngIf="searchMessage" id="error-id" class="text-danger marleft-20">
             {{searchMessage}}
           </div>
         </div>
         <div *ngIf="gridProperties.enableBackLink" class="col-md-12 col-sm-12 text-right clear-search-link">
             <p *ngIf="showBackLink"><a href="javascript:void(0);" (click)="filter('', true, 'viewAllLink')">{{gridProperties.backLinkText}}</a></p>
             <div *ngIf="!showBackLink && !gridData.length" class="clearFix"></div>
         </div>
         <p id="totalCount" tabindex="-1" *ngIf="gridProperties.showPaginationIndex && showTable && paginations.totalRecords" class="col-md-4 col-sm-12">Showing {{startIndex+1}} - {{startIndex + paginations.recordsPerPage > paginations.totalRecords ? paginations.totalRecords
           : startIndex + paginations.recordsPerPage }} of {{paginations.totalRecords}}</p>
     </div>
   </div>
   
   <p *ngIf="searchDescriptions" class="search-desc">{{searchDescriptions}}</p>

   <ng-container 
      *ngIf="( gridProperties.multiSelect || gridProperties.columnDefinitions[0].type === 'CHECKBOX' 
                || gridProperties.columnDefinitions[0].type === 'RADIO'); 
             else customGrid">

        <fieldset class="fieldset">
          <legend class="offscreen">{{ gridProperties.multiSelect ? 
            gridProperties.columnDefinitions[0].caption : 
            gridProperties.columnDefinitions[1].caption }}
          </legend>
          <ng-container *ngTemplateOutlet="customGrid"></ng-container>
        </fieldset>

   </ng-container>

   <div class="pagination" *ngIf="paginations.totalRecords > paginations.recordsPerPage && showTable">
     <app-pagination [hideGoToPage]="paginations.hideGoToPage" [startIndex]="startIndex" [totalRecords]="paginations.totalRecords" [recordsPerPage]="paginations.recordsPerPage"
       (pageChange)="onPageChange($event)"></app-pagination>
   </div>
  </div>
 </div>





 <!-- Custom grid starts here -->
 <ng-template #customGrid>
  <div class="grid-table" *ngIf="showTable" >
    <table class="table" [ngClass]="{'no-border': isABMFanSelectionPage}">
      <thead>
        <tr>

          <th scope="col" *ngIf="gridProperties.columnDefinitions.length > showhigherpriorities && maxPriority > showhigherpriorities && gridData.length">&nbsp;</th>
          <th scope="col"  class= "checkboxgrid"  *ngIf="gridProperties.multiSelect || (isMobileView && isABMFanSelectionPage)" [ngClass]="{'no-border': isABMFanSelectionPage, 'captionText-hide': isABMFanSelectionPage}">
            <div class="text-center" *ngIf="!gridProperties.disableSelectAll">
              <label class="checkbox" style="bottom: 4px;">
                <input (blur)="ariaLabel ?  handleHeadingBlur($event) : ariaLabel" (focus)="ariaLabel ? ariaLabel : handleHeadingFocus($event)" class="application-list-selector" [checked]="allRowsSelected" [disabled]="gridProperties.disableGrid" [attr.aria-label]="ariaLabel" (change)="multiSelectAction($event)" type="checkbox">
                <i class="skin" *ngIf="gridData.length"></i>
              <span></span>
              <div class="hide-element">Check box</div>
              </label>
            </div>
          </th>
          <th scope="col" [className]="col.cssClass" *ngFor="let col of gridProperties.columnDefinitions" [hidden]="col.priority > showhigherpriorities" [ngClass]="{'table-header no-border': isABMFanSelectionPage, 'mobile-header' : (isABMFanSelectionPage && isMobileView &&  col.caption !== 'Foundation account(s)')}" style="text-align: left;">
            
            <span *ngIf="(gridProperties.enableSorting && col.enableSorting && gridData.length)"  (keydown.enter)="(gridProperties.enableSorting && col.enableSorting && sort(col));"
              [ngClass]="{pointer:(gridProperties.enableSorting && col.enableSorting)}" tabindex="0" (click)="sort(col)"
              (blur)="handleSortBlur( $event, true )" (focus)="handleSortFocus( $event, true )">
              <a [attr.aria-hidden]="hideSortHeadRead" (blur)="handleSortBlur( $event, false )" (focus)="handleSortFocus( $event, false )" tabindex="0" aria-live="polite" [attr.aria-label]="col.sortDirection === 'Asc'? 'Sort descending - '+col.caption : 'Sort ascending - '+col.caption" class="sort-label"> {{col.caption}} </a>
              <span *ngIf="col.sortDirection === 'Default'" [attr.aria-hidden]="hideSortHeadRead" [attr.aria-label]="changeSortOrderAriaLabel"><i class='icon-arrows-sort-arrow down' aria-hidden="true">  </i></span>
              <span *ngIf="col.sortDirection === 'Desc'" [attr.aria-hidden]="hideSortHeadRead" [attr.aria-label]="changeSortOrderAriaLabel"><i class='icon-arrows-sort-arrow active' aria-hidden="true">  </i></span>
              <span *ngIf="col.sortDirection === 'Asc'" [attr.aria-hidden]="hideSortHeadRead" [attr.aria-label]="changeSortOrderAriaLabel"><i class='icon-arrows-sort-arrow active down' aria-hidden="true">  </i></span>
              </span>
                        

              <span *ngIf="(!gridProperties.enableSorting || !col.enableSorting || !gridData.length)">
                <span *ngIf="!isMobileView">{{col.caption}}
                  <div *ngIf="col.caption === 'Enroll existing devices?'" style="display: inline-flex;position:relative;">
                    <i class="icon-flat-faq tooltip-icon faq-tooltip-icon tooltip-new-zte" style="right: 2px; top: -1px;" tabindex="0" aria-describedby="inputhelp"
                    (mouseenter)="onTooltipIconEnter($event)" (mouseleave)="onTooltipIconLeave($event)" aria-label="Help" (keydown)="onTooltipKeydown($event)"></i>
                          <div role="tooltip" (mouseenter)="onTooltipContentEnter()" (mouseleave)="onTooltipContentLeave()" [ngClass]="{'tooltip-texts' : gridData.length === 1, 'helperText-kme' : gridData.length === 3, 'helperText-abm' : gridData.length === 2}" class="helper-text" id="inputhelp" style="max-width: 265px !important; width: 265px !important; top: auto !important; bottom: 27px; left: -123px; right: auto; margin: 0 auto; float: none;">
                            Enrolling existing devices will pull any eligible device associated to an active AT&T line on the selected FAN(s) and submit them for enrollment.  
                          </div>
                  </div>
                </span>

                <span *ngIf="isMobileView && isABMFanSelectionPage" [ngClass]="{ accountHeader: isMobileView && isABMFanSelectionPage && col.caption == 'Foundation account(s)'}">{{(col.caption == "Foundation account(s)" ? "Account(s)": "Enroll?")}}
                  <div *ngIf="col.caption === 'Enroll existing devices?'" style="display: inline-flex;position:relative;">
                    <i class="icon-flat-faq tooltip-icon faq-tooltip-icon tooltip-new-zte" style="right: 2px; top: -1px !important;" tabindex="0" aria-describedby="inputhelp"
                        (mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)" aria-label="Help"></i>
                          <div role="tooltip" [ngClass]="{'tooltip-texts' : gridData.length === 1, 'helperText-kme' : gridData.length === 3, 'helperText-abm' : gridData.length === 2}" class="helper-text" id="inputhelp" style="max-width: 265px !important; width: 265px !important; top: auto !important; bottom: 27px; left: -228px !important; right: auto; margin: 0 auto; float: none;">
                            Enrolling existing devices will pull any eligible device associated to an active AT&T line on the selected FAN(s) and submit them for enrollment.  
                          </div>
                  </div>
                </span>
                <span *ngIf="isMobileView && !isABMFanSelectionPage">
                  {{col.caption}}
                </span>
                <span class="captionText" *ngIf="!col.caption">Select</span>
              </span>

              <div *ngIf="col.field === 'source'" class="legend-container" (mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)">
                <span class="legend-label">.</span>
                <div class="legend-content left-tooltip" role="tooltip" [innerHTML]="col.headerTooltip">
                </div>
              </div>
          </th>
        </tr>
      </thead>
      <tbody *ngFor="let row of gridData;let isOdd=odd; let i = index;" [ngClass]="{ odd: isOdd && !isABMFanSelectionPage, openhiddenrow:row.accordion, rowdisabled:gridProperties.disableGrid || (gridProperties.disableRow && ((!gridProperties.disableRowConditionInverse && row[gridProperties.disableRowCondition.field] === gridProperties.disableRowCondition.value) || (gridProperties.disableRowConditionInverse && row[gridProperties.disableRowCondition.field] !== gridProperties.disableRowCondition.value)))}">
        <tr>
          <td role="tablist" *ngIf="gridProperties.columnDefinitions.length > showhigherpriorities && maxPriority > showhigherpriorities ">
              <span role="tab" (click)="row.accordion = row.accordion === undefined ? true : !row.accordion;" (keydown.enter)="row.accordion = row.accordion === undefined ? true : !row.accordion;" tabindex="0" [ngClass]="{'icon-accordion-plus':!row.accordion, 'icon-accordion-minus':row.accordion}" [attr.aria-expanded]="row.accordion ? true : false"></span>    
          </td>
          <td *ngIf="gridProperties.multiSelect" [ngClass]="{'no-border': isABMFanSelectionPage, 'checkbox-alignment': isABMFanSelectionPage}">
            <div class="text-center">
              <div class="checkbox">
              <input #inputCheckbox id="inputCheckbox-{{i+1}}" [disabled]="gridProperties.disableGrid || (gridProperties.disableRow && ((!gridProperties.disableRowConditionInverse && row[gridProperties.disableRowCondition.field] === gridProperties.disableRowCondition.value) || (gridProperties.disableRowConditionInverse && row[gridProperties.disableRowCondition.field] !== gridProperties.disableRowCondition.value))) || row.isAppleDEP" (change)="singleSelectAction(row, $event)" [checked]="row.selected" type="checkbox">
                <i class="skin" (click)="inputCheckbox.click()"></i>
              <span></span>
              <div class="hide-element">Check box</div>
              </div>
            </div>
          </td>
          <td *ngFor="let col of gridProperties.columnDefinitions; let j = index" [hidden]="col.priority > showhigherpriorities" [ngClass]="{'no-border': isABMFanSelectionPage, 'align-fans': isABMFanSelectionPage}" (dblclick)="onDoubleClick(row[col.field], $event)">
            <div [ngSwitch]="col.type">
              <div *ngSwitchCase="'HYPERLINK'">
                <div [innerHtml]="row[col.field]" (click)="linkAction(row,col.field);"> </div>
              </div>
              <div *ngSwitchCase="'LINK'">
                <a href="javascript:void(0);" (click)="linkAction(row,col.field);">{{row[col.field]}}</a>
              </div>
              <div *ngSwitchCase="'CHECKBOX'" class="text-center">
                <label aria-label="checkbox" class="checkbox" >
                <input (change)="selectionChanges(row,$event)" type="checkbox" [checked]="row[col.field] ? row[col.field] : false ">
                <i class="skin"></i>
                <span></span>
                <div class="hide-element">Check box</div> 
                </label>
              </div>
              <div *ngSwitchCase="'RADIO'" class="text-center radio">
                <input #inputRadio id="inputCheckbox-{{i+1}}" (change)="singleSelectionChanges(row,$event)" name="singleGroup" type="radio" [checked]="row[col.field] ? row[col.field] : false ">
                <i class="skin" (click)="inputRadio.click()"></i>
                <span></span>
                <div class="hide-element">radio button</div>                
              </div>
              <div *ngSwitchCase="'CUSTOMCONTENT'">
                <ng-container 
                      *ngIf="contentChildren"
                      [ngTemplateOutlet]="contentChildren[col.templateIndex]"
                      [ngTemplateOutletContext]="{row:row}">
                </ng-container>
              </div>
              <div *ngSwitchCase="'CUSTOMTEMPLATE'">
                  <label class="inputCheckboxLabel" for="inputCheckbox-{{i+1}}" attr.aria-label="Select checkbox for {{col.caption}} {{row[col.field]}}">
                    <a *ngIf="row.appName" tabindex="0" attr.aria-label="Opens a modal dialog for {{ row.appName }}" (click)="gridProperties.callbacks[col.customTemplate](dynamicElement, row, col.field, this, $event)" class="app-name">{{ row.appName }}</a>
                    <div #dynamicElement (click)="gridProperties.callbacks[col.customTemplate](dynamicElement, row, col.field, this, $event, col)" [innerHtml]="gridProperties.callbacks[col.customTemplate](dynamicElement, row, col.field, this, 'template', col)"></div>
                    <a *ngIf="row.profileName" tabindex="0" attr.aria-label="Link to open fan deployment page for {{ row.profileName }}" (click)="gridProperties.callbacks[col.customTemplate](dynamicElement, row, col.field, this, $event)" class='fan-profile'>{{ row.profileName }}</a>
                  </label>
              </div>
              <div *ngSwitchDefault  class="custumgrid-field"> 
                <label *ngIf="!isMobileView" class="inputCheckboxLabel" for="inputCheckbox-{{i+1}}" 
                attr.aria-label="
                {{
                  ( (gridProperties.multiSelect || gridProperties.columnDefinitions[0].type === 'CHECKBOX') && j < 1 ) ? 'Select checkbox for' :
                  ( gridProperties.columnDefinitions[0].type === 'RADIO' ) ? 'Select radio for' : ''
                }}  
                {{col.caption}} {{row[col.field]}}">
                  {{row[col.field]}}  {{row[col.fanName] ? " - " +row[col.fanName] : " "}}
                </label>

                <label *ngIf="isMobileView" class="inputCheckboxLabel" for="inputCheckbox-{{i+1}}" 
                attr.aria-label="
                {{
                  ( (gridProperties.multiSelect || gridProperties.columnDefinitions[0].type === 'CHECKBOX') && j < 1 ) ? 'Select checkbox for' :
                  ( gridProperties.columnDefinitions[0].type === 'RADIO' ) ? 'Select radio for' : ''
                }}  
                {{col.caption}} {{row[col.field]}}">
                  {{row[col.field]}}
                </label>
              <div *ngIf="row.isAppleDEP" style="display: inline-flex; position: relative;">
                <i class="icon-flat-faq tooltip-icon faq-tooltip-icon tooltip-new-zte" style="right: 2px; top: -1px !important;" tabindex="0" aria-describedby="inputhelp"
                    (mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)" aria-label="Help"></i>
                      <div role="tooltip" [ngClass]="{ 'appleDEP-content': row.isAppleDEP && i === 0 }" class="appleDEP-text helper-text" id="inputhelp" style="float: none; width: 300px !important; max-width: 300px !important; left: -143px !important; right: auto !important; margin: 0 auto !important; top: auto !important; bottom: 27px !important; height: auto !important;">
                        <p style="margin-bottom: 5px !important;"><b>FAN Ineligible.</b></p>
                        An existing ABM ID is registered to this account. To make changes, please contact your AT&T account representative or visit the Support tab for assistance.  
                      </div>
              </div>
              </div>
            </div>
          </td>
        </tr>
        
        <tr *ngIf="row.accordion">
          <td *ngIf="gridProperties.columnDefinitions.length > showhigherpriorities">
            &nbsp;
          </td>
          <td *ngIf="gridProperties.multiSelect">
            &nbsp;
          </td>
          <td [colSpan]="gridProperties.columnDefinitions.length">
            <div class="tablehiddendata row" *ngFor="let col of gridProperties.columnDefinitions" [hidden]="col.priority <= showhigherpriorities">
              <div [ngSwitch]="col.type" class="hiddenswitch">
                <span [className]="col.cssClass"> {{col.caption}} </span>
                <div *ngSwitchCase="'HYPERLINK'">
                  <div [innerHtml]="row[col.field]" (click)="linkAction(row,col.field);"> </div>
                </div>
                <div *ngSwitchCase="'LINK'">
                  <a href="javascript:void(0);" (click)="linkAction(row,col.field);">{{row[col.field]}}</a>
                </div>
                <div *ngSwitchCase="'CHECKBOX'" class="text-center">
                  <label aria-label="checkbox" class="checkbox">
                  <input (change)="selectionChanges(row,$event)" type="checkbox" [checked]="row[col.field] ? row[col.field] : false ">
                  <i class="skin"></i>
                  <span></span>
                  <div class="hide-element">Check box</div>
                  </label>
                </div>
                <div *ngSwitchCase="'RADIO'" class="text-center">
                  <label class="radio">
                  <input (change)="singleSelectionChanges(row,$event)" name="singleGroup" type="radio" [checked]="row[col.field] ? row[col.field] : false ">
                  <i class="skin"></i>
                  <span></span>
                  <div class="hide-element">radio button</div>
                  </label>
                </div>
                <div *ngSwitchCase="'CUSTOMTEMPLATE'">
                  <div #dynamicElement [innerHtml]="gridProperties.callbacks[col.customTemplate](dynamicElement, row, col.field, gridProperties, 'template' )"></div>
                </div>
                <div *ngSwitchDefault  class="custumgrid-field"> {{row[col.field]}}
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!gridData.length">
        <tr *ngIf="!gridProperties.isEmptyMessageInRow">
          <td *ngIf="gridProperties.multiSelect"></td>
          <td *ngFor="let col of gridProperties.columnDefinitions" [hidden]="col.priority > showhigherpriorities">
            <div *ngIf="col.field === filteredColumns[0]">{{gridProperties.emptyMessage}}</div>
          </td>
        </tr>
        <tr *ngIf="gridProperties.isEmptyMessageInRow">
          <td [colSpan]="gridProperties.columnDefinitions.length + (gridProperties.multiSelect ? 1 : 0)">
            <div style="text-align: center;">{{gridProperties.emptyMessage}}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
 </ng-template>
